/* eslint-disable */
// todo: refactor ECG logic.
// todo: refactor patient summary into a separate shared component.
// todo: so many states... what's the proper way of handling more complex structures like ours?
import EnrollNewPatientForm from '@shared/enroll-new-patient-form/EnrollNewPatientForm'
import { EmptyGraph } from '@utils/constants'
import React, { useContext, useEffect, useState } from 'react'
import { Bar, Line } from 'react-chartjs-2'
import moment from 'moment'
import ContactForm from '@shared/contact-form/ContactForm'
import TopSection from '@shared/top-section/TopSection'
import {
  formatPhoneNumbers,
  generateDoubleLineGraphData,
  generateECGGraphData,
  generateSingleLineGraphData,
  generateSPO2GraphData,
  capitalize,
  epochToDDMMYY
} from '@utils/functions'
import styles from './PatientDetails.module.scss'
import { UserContext } from '@context/UserContext'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Tooltip,
  Paper
} from '@mui/material'
import EditPatientModal from '@shared/edit-patient-modal/EditPatientModal'
import NewAppointmentModal from '@shared/new-appointment-modal/NewAppointmentModal'
import NewNotesModal from '@shared/new-notes-modal/NewNotesModal'
import ViewAlertModal from '@shared/view-alert-modal/ViewAlertModal'
import ViewAppointmentModal from '@shared/view-appointment-modal/ViewAppointmentModal'
import ViewCommunicationModal from '@shared/view-communication-modal/ViewCommunicationModal'
import ViewNoteModal from '@shared/view-note-modal/ViewNoteModal'
import ViewSurveyResponseModal from '@shared/view-survey-response-modal/ViewSurveyResponseModal'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import ClinicvuService from 'services/Clinicvu/Clinicvu.service'
import ECGVisualization from './ECGVisualization'
import NewMedicationModal from '@shared/new-medication-modal/NewMedicationModal'
import ViewMedicationModal from '@shared/view-medication-modal/ViewMedicationModal'
import {
  MdContactPhone,
  MdNoteAdd,
  MdEventNote,
  MdLocalPharmacy
} from 'react-icons/md'
// TODO: figure out what "retake" is supposed to do.
// TODO: figure out the deal with days of the week and whether we are going to display them or not.
// TODO: What are the colors associated with each care plan?

const Colors = {
  light: {
    green: '#4CAF50',
    televu_blue: '#0096FF',
    yellow: '#FFEB3B',
    orange: '#FF9800',
    red: '#F44336'
  }
}

const getAdherenceColor = (adherence) => {
  const value = parseInt(adherence)
  if (value >= 90) return Colors.light.green
  if (value >= 75) return Colors.light.televu_blue
  if (value >= 50) return Colors.light.yellow
  if (value >= 25) return Colors.light.orange
  return Colors.light.red
}

const PatientDetails = () => {
  const [editPatient, setEditPatient] = useState(false)

  const [tempData, setTempData] = useState(EmptyGraph)
  const [weightData, setWeightData] = useState(EmptyGraph)
  const [bloodPressureData, setBloodPressureData] = useState(EmptyGraph)
  const [spo2Data, setSpo2Data] = useState(EmptyGraph)
  const [ecgData, setecgData] = useState(EmptyGraph)
  const [surveyGroups, setSurveyGroups] = useState(null)

  const [open, setOpen] = useState(false)

  const [patient, setPatient] = useState(null)
  const [ecg, setEcg] = useState(null)

  const [isOpenNotesModal, setIsOpenNotesModal] = useState(false)
  const [isOpenEditPatientModal, setIsOpenEditPatientModal] = useState(false)
  const [isOpenAppointmentModal, setIsOpenAppointmentModal] = useState(false)
  const [isCallingPatient, setIsCallingPatient] = useState(false)
  const [isGeneratingTasks, setIsGeneratingTasks] = useState(false)
  const [patientNoteText, setPatientNoteText] = useState('')
  const [patientIsReviewed, setPatientIsReviewed] = useState(null)
  const [selectedAppointment, setSelectedAppointment] = useState(null)
  const [selectedCommunication, setSelectedCommunication] = useState(null)

  const [selectedNote, setSelectedNote] = useState(null)
  const [selectedNotePractitioner, setSelectedNotePractitioner] = useState(null)
  const [selectedSurveyResponseGroup, setSelectedSurveyResponseGroup] =
    useState(null)

  const [ecgSkipCount, setEcgSkipCount] = useState(0)

  const location = useLocation()
  const [selectedAlert, setSelectedAlert] = useState(
    location.state?.alert || null
  )
  const { me } = useContext(UserContext)

  const navigate = useNavigate()

  const { patientID: id } = useParams()

  const [isOpenMedicationModal, setIsOpenMedicationModal] = useState(false)
  const [medications, setMedications] = useState([])
  const closePatientNotesModal = () => {
    setPatientNoteText('')
    setPatientIsReviewed(null)
    setIsOpenNotesModal(false)
  }
  const [selectedMedication, setSelectedMedication] = useState(null)
  const [isOpenViewMedicationModal, setIsOpenViewMedicationModal] =
    useState(false)

  const [allTasks, setAllTasks] = useState([])
  const [recentTasks, setRecentTasks] = useState([])
  const [upcomingTasks, setUpcomingTasks] = useState([])
  const [taskCategories, setTaskCategories] = useState({
    upcoming: 0,
    missed: 0,
    completed: 0
  })
  const [activeTaskFilter, setActiveTaskFilter] = useState(null)

  const [medicationCompliance, setMedicationCompliance] = useState({})
  const [complianceScore, setComplianceScore] = useState(0)

  const [callHistory, setCallHistory] = useState([])

  const fetchPatientData = async () => {
    try {
      const res = await ClinicvuService.getPatient(id)
      if (res.status !== 200) {
        throw new Error(`Was not able to fetch patient data with id: ${id}`)
      }
      setPatient(res.data)
    } catch (error) {
      console.error(error)
    }
    try {
      const callsRes = await ClinicvuService.getPatientCallHistory(id)
      setCallHistory(callsRes.data?.calls ?? [])
    } catch (error) {
      console.error('Failed to load call history', error)
    }
  }

  useEffect(() => {
    fetchPatientData()
  }, [id])

  // Function to get practitioner's name by reference
  const getPractitionerName = (reference) => {
    const practitioner = patient.compositions?.find(
      (composition) =>
        composition.resource.resourceType === 'Practitioner' &&
        composition.resource.id === reference.split('/')[1]
    )
    if (practitioner && practitioner.resource.name[0]) {
      const givenName = practitioner.resource.name[0].given?.[0] || 'NA'
      const familyName = practitioner.resource.name[0].family || 'NA'
      return `${givenName} ${familyName}`
    }
    return 'NA'
  }

  useEffect(() => {
    if (patient && patient.observations) {
      const temperatureObservations = patient.observations.filter((obs) =>
        obs.resource?.code?.coding?.some((coding) => coding.code === '8310-5')
      )
      const pulseOximetryObservations = patient.observations.filter((obs) =>
        obs.resource?.code?.coding?.some((coding) => coding.code === '59408-5')
      )
      const bloodPressureObservations = patient.observations.filter((obs) =>
        obs.resource?.code?.coding?.some((coding) => coding.code === '85354-9')
      )
      const weightObservations = patient.observations.filter((obs) =>
        obs.resource?.code?.coding?.some((coding) => coding.code === '29463-7')
      )

      const ecgObservations = patient.observations.filter((obs) =>
        obs.resource?.code?.coding?.some((coding) => coding.code === '11524-6')
      )

      if (temperatureObservations.length > 0) {
        setTempData(
          generateSingleLineGraphData(temperatureObservations, '#EA540B')
        )
      }

      if (weightObservations.length > 0) {
        setWeightData(
          generateSingleLineGraphData(weightObservations, '#1BA7A0')
        )
      }

      if (bloodPressureObservations.length > 0) {
        setBloodPressureData(
          generateDoubleLineGraphData(
            bloodPressureObservations,
            'Systollic',
            'Diastollic'
          )
        )
      }

      if (pulseOximetryObservations.length > 0) {
        setSpo2Data(
          generateSPO2GraphData(pulseOximetryObservations, '% Blood Oxygen')
        )
      }

      if (ecgObservations.length > 0) {
        ecgObservations.sort(
          (a, b) =>
            new Date(b.resource.effectiveDateTime) -
            new Date(a.resource.effectiveDateTime)
        )
        setEcg(ecgObservations)
      }

      if (patient.questionnaireResponses) {
        let responses = patient.questionnaireResponses.slice()
        responses = responses.reverse()
        setSurveyGroups(responses)
      }

      setMedications(patient.medications)

      if (patient.recentTasks || patient.upcomingTasks) {
        const processTasks = (tasks) => {
          if (!tasks) return []
          const now = new Date()

          // Categorize tasks
          tasks.forEach((task) => {
            const startDate = task.resource.restriction?.period?.start

            if (task.resource.status === 'completed') {
              task.category = 'completed'
            } else if (startDate && new Date(startDate) >= now) {
              task.category = 'upcoming'
            } else if (startDate && new Date(startDate) < now) {
              task.category = 'missed'
            } else {
              task.category = 'other'
            }
          })

          // Sort tasks with completed at bottom, then by date
          return tasks.sort((a, b) => {
            // First sort by category: upcoming and missed at top, completed at bottom
            if (a.category === 'completed' && b.category !== 'completed')
              return 1
            if (a.category !== 'completed' && b.category === 'completed')
              return -1

            // Then sort by date
            const dateA =
              a.category === 'completed'
                ? a.resource.executionPeriod?.end
                : a.resource.restriction?.period?.start

            const dateB =
              b.category === 'completed'
                ? b.resource.executionPeriod?.end
                : b.resource.restriction?.period?.start

            // For upcoming tasks, oldest first; for others, newest first
            if (a.category === 'upcoming' && b.category === 'upcoming') {
              return new Date(dateA) - new Date(dateB)
            } else {
              return new Date(dateB) - new Date(dateA)
            }
          })
        }

        const processedRecentTasks = processTasks(patient.recentTasks)
        const processedUpcomingTasks = processTasks(patient.upcomingTasks)

        // Count tasks by category
        const categories = {
          upcoming: processedRecentTasks.filter(
            (t) => t.category === 'upcoming'
          ).length,
          missed: processedRecentTasks.filter((t) => t.category === 'missed')
            .length,
          completed: processedRecentTasks.filter(
            (t) => t.category === 'completed'
          ).length
        }

        setRecentTasks(processedRecentTasks)
        setUpcomingTasks(processedUpcomingTasks)
        setTaskCategories(categories)
      }

      if (patient.compliance) {
        setComplianceScore(patient.compliance.score)
      }
    }
  }, [patient])

  useEffect(() => {
    if (ecg?.length > 0) {
      const currentEcg = ecg[ecgSkipCount]?.resource
      const ecgData =
        currentEcg?.component[7]?.valueSampledData?.data?.split(' ')
      setecgData(ecgData)
    } else {
      setecgData(EmptyGraph)
    }
  }, [ecg, editPatient, ecgSkipCount])

  const notifyPatient = async (notification) => {
    try {
      await ClinicvuService.notifyPatient(
        id,
        notification.stateRaw,
        notification.stateHTML
      )
    } catch (error) {
      console.log(error)
    }
  }

  const handleNoteSubmit = async () => {
    try {
      await ClinicvuService.addNote(patientNoteText, id, patientIsReviewed)
      setIsOpenNotesModal(false)
    } catch (e) {
      console.error(`Error occurred while updating patient alerts: ${e}`)
    }
  }

  const scheduleAppointment = async (
    topic,
    description,
    date,
    fromTime,
    toTime
  ) => {
    try {
      await ClinicvuService.createAppointment(
        id,
        topic,
        description,
        date,
        fromTime,
        toTime
      )
      setIsOpenAppointmentModal(false)
    } catch (e) {
      console.error(`Error occurred while updating patient alerts: ${e}`)
    }
  }

  const handleCallPatient = async () => {
    const patientName = patient?.name?.[0]?.given?.[0] || 'this patient'
    const patientPhone = patient?.telecom?.find((t) => t.system === 'phone')?.value
    if (!patientPhone) {
      alert('This patient does not have a phone number on file.')
      return
    }
    if (!window.confirm(`Call ${patientName} at ${patientPhone}? The voice agent will walk them through their care tasks.`)) {
      return
    }
    setIsCallingPatient(true)
    try {
      const response = await ClinicvuService.initiateVoiceCall(id)
      alert(response.data.message || 'Call initiated successfully.')
      await fetchPatientData()
    } catch (e) {
      alert('Failed to initiate call: ' + (e.response?.data?.error || e.message))
    } finally {
      setIsCallingPatient(false)
    }
  }

  const handleGenerateTasks = async () => {
    setIsGeneratingTasks(true)
    try {
      await ClinicvuService.generateTasks()
      await fetchPatientData()
      alert('Tasks generated successfully.')
    } catch (e) {
      alert('Failed to generate tasks: ' + (e.response?.data?.error || e.message))
    } finally {
      setIsGeneratingTasks(false)
    }
  }

  const handleAddMedication = async (medication) => {
    try {
      const response = await ClinicvuService.addMedication(medication)
      if (response.status === 200) {
        // Refresh patient data to show the new medication
        await fetchPatientData()
        setIsOpenMedicationModal(false)
      } else {
        console.error('Failed to add medication:', response)
      }
    } catch (error) {
      console.error('Error adding medication:', error)
    }
  }

  // Function to get task type name based on code
  const getTaskTypeName = (code) => {
    const taskTypeMap = {
      56342008: 'Temperature',
      135840009: 'Blood Pressure',
      252465000: 'SPO2',
      29303009: 'ECG',
      308113006: 'Blood Glucose',
      225171007: 'Weight',
      445988008: 'Questionnaire',
      445283009: 'Review Files'
    }

    return taskTypeMap[code] || 'Medication'
  }

  // Function to format date for display
  const formatTaskDate = (dateString) => {
    if (!dateString) return 'No date'
    return moment(dateString).format('MMM D, YYYY [at] h:mm a')
  }

  // Function to calculate 7-day compliance score for medications
  const calculateMedicationCompliance = () => {
    if (!patient || !patient.tasks || !medications) return

    const today = new Date()
    today.setHours(23, 59, 59, 999) // Set to end of current day
    const last7Days = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000)

    // Create a compliance object for each medication
    const compliance = {}

    medications.forEach((medication) => {
      const medicationId = medication.resource.id
      const medicationName =
        medication.resource.medicationCodeableConcept.text.toLowerCase()

      // Find tasks related to this medication from the last 7 days using basedOn reference
      let relatedTasks = patient.tasks.filter((task) => {
        // Check if basedOn is an array and has at least one element
        if (task.resource.basedOn && task.resource.basedOn.length > 0) {
          // Look for any reference that includes the medication ID
          const isForMedication = task.resource.basedOn.some(
            (basis) =>
              basis.reference &&
              basis.reference.includes(`MedicationRequest/${medicationId}`)
          )

          // Check if task was scheduled in the past week up to today (not future)
          let taskDate = null
          if (
            task.resource.restriction &&
            task.resource.restriction.period &&
            task.resource.restriction.period.start
          ) {
            taskDate = new Date(task.resource.restriction.period.start)
          } else if (
            task.resource.executionPeriod &&
            task.resource.executionPeriod.start
          ) {
            taskDate = new Date(task.resource.executionPeriod.start)
          }

          const isInTimeRange =
            taskDate && taskDate >= last7Days && taskDate <= today

          return isForMedication && isInTimeRange
        }
        return false
      })

      // Fallback: If no tasks found through basedOn, try to find tasks through other references
      if (relatedTasks.length === 0) {
        relatedTasks = patient.tasks.filter((task) => {
          // Try alternative methods to link tasks to medications
          let isForMedication = false

          // Check focus reference - make sure focus is treated as an array
          if (task.resource.focus) {
            // Convert focus to array if it's not already
            const focusArray = Array.isArray(task.resource.focus)
              ? task.resource.focus
              : [task.resource.focus]

            isForMedication = focusArray.some(
              (focus) =>
                focus.reference &&
                focus.reference.includes(`MedicationRequest/${medicationId}`)
            )
          }

          // Check description for medication name
          if (!isForMedication && task.resource.description) {
            isForMedication = task.resource.description
              .toLowerCase()
              .includes(medicationName)
          }

          // Check if it's a medication administration task
          if (!isForMedication && task.resource.code?.coding) {
            // Make sure coding is an array
            const codingArray = Array.isArray(task.resource.code.coding)
              ? task.resource.code.coding
              : [task.resource.code.coding]

            isForMedication = codingArray.some(
              (coding) =>
                (coding.display &&
                  coding.display.toLowerCase().includes('medication')) ||
                coding.code === '415899001' // SNOMED CT code for "Medication task"
            )

            // If it's a medication task, check if the description contains the medication name
            if (isForMedication && task.resource.description) {
              isForMedication = task.resource.description
                .toLowerCase()
                .includes(medicationName)
            } else {
              isForMedication = false
            }
          }

          // Check if task was scheduled in the last week
          let taskDate = null
          if (task.resource.restriction?.period?.start) {
            taskDate = new Date(task.resource.restriction.period.start)
          } else if (task.resource.executionPeriod?.start) {
            taskDate = new Date(task.resource.executionPeriod.start)
          } else if (task.resource.created) {
            taskDate = new Date(task.resource.created)
          }

          const isInTimeRange =
            taskDate && taskDate >= last7Days && taskDate <= today

          return isForMedication && isInTimeRange
        })
      }

      const completedTasks = relatedTasks.filter(
        (task) => task.resource.status === 'completed'
      )

      // Handle case where there are no related tasks to avoid division by zero
      if (relatedTasks.length === 0) {
        compliance[medicationId] = { score: 'N/A', completed: 0, total: 0 }
      } else {
        const complianceScore = Math.round(
          (completedTasks.length / relatedTasks.length) * 100
        )
        compliance[medicationId] = {
          score: complianceScore,
          completed: completedTasks.length,
          total: relatedTasks.length
        }
      }
    })

    setMedicationCompliance(compliance)
  }

  useEffect(() => {
    if (patient && medications) {
      calculateMedicationCompliance()
    }
  }, [patient, medications])

  // Function to filter tasks by category
  const filterTasksByCategory = (category) => {
    if (activeTaskFilter === category) {
      setActiveTaskFilter(null) // Toggle off if clicking the same filter
    } else {
      setActiveTaskFilter(category)
    }
  }

  return (
    <div className={styles.content}>
      <TopSection
        title="Patient Details"
        onBack={() =>
          navigate(
            process.env.REACT_APP_environment_type === 'clinicvu'
              ? '/patients'
              : '/users'
          )
        }
      />
      {!editPatient ? (
        <>
          {patient && (
            <div className={styles.patientSummaryBox}>
              <div className={styles.patientSummaryHeader}>
                <div className={styles.patientSummaryLeft}>
                  <div className={styles.patientName}>
                    {`${patient.name?.[0]?.given?.[0] || ''} ${patient.name?.[0]?.family || ''}`}
                  </div>
                  <div className={styles.patientDetailsRow}>
                    <span>
                      MRN#:{' '}
                      {patient?.identifier?.find(
                        (i) => i.system === 'http://hospital.smarthealthit.org'
                      )?.value || 'N/A'}
                    </span>
                    <span>
                      DOB:{' '}
                      {patient.birthDate
                        ? epochToDDMMYY(patient.birthDate)
                        : 'N/A'}
                    </span>
                    <span>
                      Age:{' '}
                      {patient.birthDate
                        ? `${moment().diff(patient.birthDate, 'years')}y`
                        : 'N/A'}
                    </span>
                    <span>
                      Sex: {patient.gender ? capitalize(patient.gender) : 'N/A'}
                    </span>
                    <span>
                      Height:{' '}
                      {patient.observations
                        ?.filter(
                          (obs) =>
                            obs.resource.code?.coding?.[0]?.system ===
                              'http://loinc.org' &&
                            obs.resource.code?.coding?.[0]?.code === '8302-2'
                        )
                        ?.sort(
                          (a, b) =>
                            new Date(b.effectiveDateTime) -
                            new Date(a.effectiveDateTime)
                        )[0]?.resource?.valueQuantity?.value || 'N/A'}{' '}
                      cm
                    </span>
                  </div>
                  <div className={styles.patientDetailsRow}>
                    <span>
                      Phone:{' '}
                      {patient.telecom?.find((t) => t.system === 'phone')?.value
                        ? formatPhoneNumbers(
                            patient.telecom.find((t) => t.system === 'phone')
                              .value
                          )
                        : 'N/A'}
                    </span>
                    <span>
                      Email:{' '}
                      {patient.telecom?.find((t) => t.system === 'email')
                        ?.value || 'N/A'}
                    </span>
                  </div>
                  <div className={styles.patientDetailsRow}>
                    <span>
                      Care Plan:{' '}
                      {patient.carePlans
                        ?.map((cp) => cp.resource.title)
                        .join(', ') || 'No care plans assigned'}
                    </span>
                  </div>
                </div>
                <div className={styles.patientSummaryRight}>
                  <div className={styles.carePlanComplianceLabel}>
                    Care Plan Compliance
                  </div>
                  <div
                    className={styles.carePlanComplianceValue}
                    style={{ color: getAdherenceColor(complianceScore) }}
                  >
                    {complianceScore}%
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className={styles['grid-container']}>
            {patient &&
              process.env.REACT_APP_environment_type === 'clinicvu' && (
                <div className={styles.card}>
                  <div className={styles.card__header}>Administration</div>
                  <div className={styles['card__content--contact']}>
                    <div className={styles.alertActionBtns}>
                      <button
                        className={styles.alertActionBtn}
                        onClick={() => setOpen(true)}
                      >
                        <img
                          src="/assets/svgs/message-square-list-svgrepo-com.svg"
                          alt="Contact"
                          className={styles['alertIcon']}
                        />
                        <span>Contact Patient</span>
                      </button>
                      <button
                        onClick={handleCallPatient}
                        disabled={isCallingPatient}
                        className={styles.alertActionBtn}
                      >
                        <MdContactPhone
                          className={styles['alertIcon']}
                          style={{ width: 20, height: 20 }}
                        />
                        <span>{isCallingPatient ? 'Calling...' : 'Call Patient'}</span>
                      </button>
                      <button
                        onClick={() => setIsOpenAppointmentModal(true)}
                        className={styles.alertActionBtn}
                      >
                        <img
                          src="/assets/svgs/calendar-alt-svgrepo-com.svg"
                          alt="Appointment"
                          className={styles['alertIcon']}
                        />
                        <span>Schedule Appointment</span>
                      </button>
                      <button
                        onClick={() => setIsOpenMedicationModal(true)}
                        className={styles.alertActionBtn}
                      >
                        <img
                          src="/assets/svgs/capsule-svgrepo-com.svg"
                          alt="Medication"
                          className={styles['alertIcon']}
                        />
                        <span>Add Medication</span>
                      </button>
                      <button
                        onClick={() => setIsOpenNotesModal(true)}
                        className={styles.alertActionBtn}
                      >
                        <img
                          src="/assets/svgs/add-file-svgrepo-com.svg"
                          alt="Add Note"
                          className={styles['alertIcon']}
                        />
                        <span>Add Note</span>
                      </button>
                      <button
                        className={styles.alertActionBtn}
                        onClick={() => setIsOpenEditPatientModal(true)}
                      >
                        <img
                          src="/assets/svgs/medical-medical-record-svgrepo-com.svg"
                          alt="Medical Record"
                          className={styles['alertIcon']}
                        />
                        <span>Edit Patient</span>
                      </button>
                      <button
                        onClick={handleGenerateTasks}
                        disabled={isGeneratingTasks}
                        className={styles.alertActionBtn}
                      >
                        <MdEventNote
                          className={styles['alertIcon']}
                          style={{ width: 20, height: 20 }}
                        />
                        <span>{isGeneratingTasks ? 'Generating...' : 'Generate Tasks'}</span>
                      </button>
                    </div>
                  </div>
                </div>
              )}

            {patient &&
              patient.detectedIssues &&
              patient.detectedIssues.length !== 0 && (
                <div className={styles.card}>
                  <div className={styles.card__header}>Alerts Summary</div>
                  <div className={styles['card__content--summary']}>
                    {patient.detectedIssues
                      .filter((issue) => {
                        const detail =
                          issue.resource.detail?.toLowerCase() || ''
                        return (
                          detail.includes('out of range') &&
                          !detail.includes('missing')
                        )
                      })
                      .sort(
                        (a, b) =>
                          new Date(b.resource.identifiedDateTime) -
                          new Date(a.resource.identifiedDateTime)
                      )
                      .map((issue, index) => (
                        <button
                          className={styles['pre-modal-btn']}
                          key={`summary-${index}`}
                          onClick={() => setSelectedAlert(issue)}
                        >
                          {issue.resource.detail} on{' '}
                          {moment(issue.resource.identifiedDateTime).format(
                            'DD-MMM'
                          )}
                        </button>
                      ))}
                  </div>
                </div>
              )}

            {recentTasks && recentTasks.length > 0 && (
              <div className={styles.card}>
                <div className={styles.card__header}>
                  Recent Tasks
                  <div className={styles.taskStats}>
                    {taskCategories.upcoming > 0 && (
                      <span
                        className={`${styles.taskCount} ${styles.upcomingCount} ${activeTaskFilter === 'upcoming' ? styles.activeFilter : ''}`}
                        onClick={() => filterTasksByCategory('upcoming')}
                        style={{ cursor: 'pointer' }}
                      >
                        {taskCategories.upcoming} Upcoming
                      </span>
                    )}
                    {taskCategories.missed > 0 && (
                      <span
                        className={`${styles.taskCount} ${styles.missedCount} ${activeTaskFilter === 'missed' ? styles.activeFilter : ''}`}
                        onClick={() => filterTasksByCategory('missed')}
                        style={{ cursor: 'pointer' }}
                      >
                        {taskCategories.missed} Missed
                      </span>
                    )}
                    {taskCategories.completed > 0 && (
                      <span
                        className={`${styles.taskCount} ${styles.completedCount} ${activeTaskFilter === 'completed' ? styles.activeFilter : ''}`}
                        onClick={() => filterTasksByCategory('completed')}
                        style={{ cursor: 'pointer' }}
                      >
                        {taskCategories.completed} Completed
                      </span>
                    )}
                    {activeTaskFilter && (
                      <span
                        className={styles.clearFilter}
                        onClick={() => setActiveTaskFilter(null)}
                        style={{
                          cursor: 'pointer',
                          marginLeft: '10px',
                          fontSize: '14px'
                        }}
                      >
                        (Clear filter)
                      </span>
                    )}
                  </div>
                </div>
                <div className={styles['card__content--summary']}>
                  {recentTasks
                    .filter(
                      (task) =>
                        !activeTaskFilter || task.category === activeTaskFilter
                    )
                    .map((task, index) => {
                      const code = task.resource.code?.coding?.[0]?.code
                      const taskType = getTaskTypeName(code)

                      // Get date based on task category
                      let dateString, dateLabel
                      if (task.category === 'completed') {
                        dateString = task.resource.executionPeriod?.end
                        dateLabel = 'Completed'
                      } else {
                        dateString = task.resource.restriction?.period?.start
                        dateLabel = 'Scheduled'
                      }

                      const formattedDate = formatTaskDate(dateString)

                      return (
                        <div
                          key={`task-${index}`}
                          className={`${styles.taskItem} ${styles[task.category + 'Task']}`}
                        >
                          <div className={styles.taskType}>{taskType}</div>
                          <div className={styles.taskDescription}>
                            {task.resource.description}
                          </div>
                          <div className={styles.taskDate}>
                            {dateLabel}: {formattedDate}
                          </div>
                          <div className={styles.taskStatus}>
                            <span
                              className={`${styles.statusBadge} ${styles[task.category]}`}
                            >
                              {task.category}
                            </span>
                            {task.resource.output &&
                              task.resource.output.length > 0 && (
                                <span className={styles.resultLink}>
                                  View Result
                                </span>
                              )}
                          </div>
                        </div>
                      )
                    })}
                </div>
              </div>
            )}

            {upcomingTasks && upcomingTasks.length > 0 && (
              <div className={styles.card}>
                <div className={styles.card__header}>Upcoming Tasks</div>
                <div className={styles['card__content--summary']}>
                  {upcomingTasks.map((task, index) => {
                      const code = task.resource.code?.coding?.[0]?.code
                      const taskType = getTaskTypeName(code)

                      // Get date based on task category
                      let dateString, dateLabel
                      if (task.category === 'completed') {
                        dateString = task.resource.executionPeriod?.end
                        dateLabel = 'Completed'
                      } else {
                        dateString = task.resource.restriction?.period?.start
                        dateLabel = 'Scheduled'
                      }

                      const formattedDate = formatTaskDate(dateString)

                      return (
                        <div
                          key={`task-${index}`}
                          className={`${styles.taskItem} ${styles[task.category + 'Task']}`}
                        >
                          <div className={styles.taskType}>{taskType}</div>
                          <div className={styles.taskDescription}>
                            {task.resource.description}
                          </div>
                          <div className={styles.taskDate}>
                            {dateLabel}: {formattedDate}
                          </div>
                          <div className={styles.taskStatus}>
                            <span
                              className={`${styles.statusBadge} ${styles[task.category]}`}
                            >
                              {task.category}
                            </span>
                            {task.resource.output &&
                              task.resource.output.length > 0 && (
                                <span className={styles.resultLink}>
                                  View Result
                                </span>
                              )}
                          </div>
                        </div>
                      )
                    })}
                </div>
              </div>
            )}

            {patient && patient.carePlans && (
              <div className={styles.card}>
                <div className={styles.card__header}>Care Plans</div>
                <div className={styles['card__content--summary']}>
                  {patient.carePlans.map((carePlan, index) => (
                    <div
                      key={`summary-${index}`}
                      className={styles['care-plan']}
                    >
                      <div
                        className={styles['care-plan__icon']}
                        style={{
                          backgroundColor: carePlan.color
                        }}
                      ></div>
                      <span className={styles['care-plan__text']}>
                        {carePlan.resource.title}
                      </span>
                    </div>
                  ))}
                  {process.env.REACT_APP_environment_type === 'clinicvu' && (
                    <button
                      className={styles.btn}
                      onClick={() => setEditPatient(true)}
                    >
                      Change patient plans
                    </button>
                  )}
                </div>
              </div>
            )}
            {patient && tempData.labels.length !== 0 && (
              <div className={styles.card}>
                <div className={styles.card__header}>Temperature</div>
                <div className={styles.card__content}>
                  <Line data={tempData} options={{ responsive: true }} />
                </div>
              </div>
            )}
            {patient && bloodPressureData.labels.length !== 0 && (
              <div className={styles.card}>
                <div className={styles.card__header}>Blood Pressure</div>
                <div className={styles.card__content}>
                  <Line
                    data={bloodPressureData}
                    options={{ responsive: true }}
                  />
                </div>
              </div>
            )}
            {patient && spo2Data.labels.length !== 0 && (
              <div className={styles.card}>
                <div className={styles.card__header}>SpO2</div>
                <div className={styles.card__content}>
                  <Bar
                    data={spo2Data}
                    options={{
                      responsive: true,
                      scales: { y: { min: 85, max: 100 } }
                    }}
                  />
                </div>
              </div>
            )}

            {patient && weightData.labels.length !== 0 && (
              <div className={styles.card}>
                <div className={styles.card__header}>Weight</div>
                <div className={styles.card__content}>
                  <Line data={weightData} options={{ responsive: true }} />
                </div>
              </div>
            )}

            {patient && medications && medications.length > 0 && (
              <div className={styles.card}>
                <div className={styles.card__header}>
                  Medications
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px'
                    }}
                  >
                    <Tooltip
                      title="7-day medication compliance score shows the percentage of completed medication tasks in the last week"
                      arrow
                    >
                      <span
                        style={{
                          fontSize: '16px',
                          marginLeft: '5px',
                          cursor: 'help'
                        }}
                      >
                        ⓘ
                      </span>
                    </Tooltip>
                    <Tooltip title="Refresh compliance scores" arrow>
                      <button
                        onClick={calculateMedicationCompliance}
                        style={{
                          background: 'transparent',
                          border: 'none',
                          cursor: 'pointer',
                          fontSize: '16px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        ↻
                      </button>
                    </Tooltip>
                  </div>
                </div>
                <div className={styles['card__content--summary']}>
                  {medications.map((medication, index) => (
                    <div
                      key={`medication-${index}`}
                      className={styles.medicationItem}
                    >
                      <button
                        className={styles['pre-modal-btn']}
                        onClick={() => {
                          setSelectedMedication(medication)
                          setIsOpenViewMedicationModal(true)
                        }}
                      >
                        {`${medication.resource.medicationCodeableConcept.text}`}
                      </button>
                      <div className={styles.complianceIndicator}>
                        {medicationCompliance[medication.resource.id] !==
                          undefined && (
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              marginLeft: '20px'
                            }}
                          >
                            <span>Medication Compliance</span>
                            {medicationCompliance[medication.resource.id]
                              .score !== 'N/A' ? (
                              <>
                                <div
                                  style={{
                                    width: '12px',
                                    height: '12px',
                                    borderRadius: '50%',
                                    backgroundColor: getAdherenceColor(
                                      medicationCompliance[
                                        medication.resource.id
                                      ].score
                                    )
                                  }}
                                />
                                <span
                                  style={{
                                    color: getAdherenceColor(
                                      medicationCompliance[
                                        medication.resource.id
                                      ].score
                                    ),
                                    fontWeight: 'bold'
                                  }}
                                >
                                  {
                                    medicationCompliance[medication.resource.id]
                                      .score
                                  }
                                  %
                                </span>
                              </>
                            ) : (
                              <Tooltip
                                title="No medication tasks found in the last 7 days. Try scheduling tasks for this medication."
                                arrow
                              >
                                <span style={{ color: '#777', cursor: 'help' }}>
                                  No recent tasks
                                </span>
                              </Tooltip>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {patient &&
              patient.compositions &&
              patient.compositions.length !== 0 && (
                <div className={styles.card}>
                  <div className={styles.card__header}>Notes</div>
                  <div className={styles['card__content--summary']}>
                    {patient.compositions
                      ?.filter(
                        (composition) =>
                          composition.resource.resourceType === 'Composition'
                      )
                      ?.sort(
                        (a, b) =>
                          new Date(b.resource.date) - new Date(a.resource.date)
                      )
                      ?.map((composition, index) => (
                        <button
                          className={styles['pre-modal-btn']}
                          key={`composition-${index}`}
                          onClick={() => {
                            setSelectedNote(composition)
                            setSelectedNotePractitioner(
                              getPractitionerName(
                                composition.resource.author[0].reference
                              )
                            )
                          }}
                        >{`${getPractitionerName(
                          composition.resource.author[0].reference
                        )} - ${moment(composition.resource.date).format(
                          'MMM Do YYYY, h:mm a'
                        )}`}</button>
                      ))}
                  </div>
                </div>
              )}

            {patient && surveyGroups && surveyGroups.length !== 0 && (
              <div className={styles.card}>
                <div className={styles.card__header}>
                  Questionnaire Responses
                </div>
                <div className={styles['card__content--summary']}>
                  {surveyGroups?.map((surveyResponseGroup, index) => (
                    <button
                      className={styles['pre-modal-btn']}
                      key={`survey-response-${index}`}
                      onClick={() =>
                        setSelectedSurveyResponseGroup(surveyResponseGroup)
                      }
                    >{`Submitted - ${moment(
                      surveyResponseGroup?.created_at
                    ).format('MMM Do YY, h:mm a')}`}</button>
                  ))}
                </div>
              </div>
            )}
            {patient &&
              patient.appointments &&
              patient.appointments.length !== 0 && (
                <div className={styles.card}>
                  <div className={styles.card__header}>Appointments</div>
                  <div className={styles['card__content--summary']}>
                    {patient.appointments
                      .filter(
                        (appointment) =>
                          appointment.resource.resourceType === 'Appointment' &&
                          moment(appointment.resource.start).isAfter(
                            moment().subtract(1, 'days')
                          )
                      )
                      .sort((a, b) =>
                        a.resource.start > b.resource.start ? 1 : -1
                      )
                      .map((patientAppointment, index) => (
                        <button
                          className={styles['pre-modal-btn']}
                          key={`appointment-${index}`}
                          onClick={() =>
                            setSelectedAppointment(patientAppointment)
                          }
                        >{`${patientAppointment?.resource.description || 'NA'} - ${moment(
                          patientAppointment?.resource.start
                        ).format('MMM Do YY, h:mm a')} - ${moment(
                          patientAppointment?.resource.end
                        ).format('h:mm a')}`}</button>
                      ))}
                  </div>
                </div>
              )}

            {patient &&
              patient.communication &&
              patient.communication.length !== 0 && (
                <div className={styles.card}>
                  <div className={styles.card__header}>Communication</div>
                  <div className={styles['card__content--summary']}>
                    {patient.communication
                      .filter(
                        (communication) =>
                          communication.resource.resourceType ===
                          'Communication'
                      )
                      .sort((a, b) =>
                        a.resource.sent < b.resource.sent ? 1 : -1
                      )
                      .map((communication, index) => {
                        const isSent =
                          communication.resource.sender?.reference.includes(
                            'Practitioner'
                          )
                        const label = isSent ? 'Sent' : 'Received'
                        return (
                          <button
                            className={styles['pre-modal-btn']}
                            key={`communication-${index}`}
                            onClick={() =>
                              setSelectedCommunication(communication)
                            }
                          >{`${label} - ${moment(
                            communication?.resource.sent
                          ).format('MMM Do YY, h:mm a')}`}</button>
                        )
                      })}
                  </div>
                </div>
              )}

            {callHistory && callHistory.length !== 0 && (
              <div className={styles.card}>
                <div className={styles.card__header}>Calls</div>
                <div className={styles['card__content--summary']}>
                  {callHistory.map((call, index) => {
                    const answered =
                      call.status === 'completed' && call.duration_seconds > 0
                    const missed = ['no-answer', 'busy', 'failed'].includes(
                      call.status
                    )
                    const label = answered
                      ? 'Answered'
                      : missed
                      ? 'Missed'
                      : capitalize(call.status || 'Unknown')
                    const duration = call.duration_seconds
                      ? ` - ${Math.floor(call.duration_seconds / 60)}m ${
                          call.duration_seconds % 60
                        }s`
                      : ''
                    const when = moment(call.created_at).format(
                      'MMM Do YY, h:mm a'
                    )
                    return (
                      <div
                        className={styles['pre-modal-btn']}
                        key={`call-${call.id ?? index}`}
                        style={{ cursor: 'default' }}
                      >
                        {`${label}${duration} - ${when}`}
                      </div>
                    )
                  })}
                </div>
              </div>
            )}
          </div>
          {patient && ecgData && Object.keys(ecgData).length > 2 && (
            <ECGVisualization
              ecg={ecg}
              ecgData={ecgData}
              ecgSkipCount={ecgSkipCount}
              setEcgSkipCount={setEcgSkipCount}
            />
          )}
        </>
      ) : (
        <EnrollNewPatientForm
          setShowNew={setEditPatient}
          goBack={() => setEditPatient(false)}
          currPatient={patient}
        />
      )}

      <ContactForm
        open={open}
        setOpen={setOpen}
        notifyPatient={notifyPatient}
      />

      <NewNotesModal
        isOpenNotesModal={isOpenNotesModal}
        setIsOpenNotesModal={setIsOpenNotesModal}
        me={me}
        patientNoteText={patientNoteText}
        patientIsReviewed={patientIsReviewed}
        setPatientIsReviewed={setPatientIsReviewed}
        handleNoteSubmit={handleNoteSubmit}
        closePatientNotesModal={closePatientNotesModal}
        setPatientNoteText={setPatientNoteText}
      />

      <ViewNoteModal
        selectedNote={selectedNote}
        selectedNotePractitioner={selectedNotePractitioner}
        setSelectedNote={setSelectedNote}
      />

      <ViewSurveyResponseModal
        selectedSurveyResponseGroup={selectedSurveyResponseGroup}
        setSelectedSurveyResponseGroup={setSelectedSurveyResponseGroup}
      />

      <ViewAlertModal
        selectedAlert={selectedAlert}
        setSelectedAlert={setSelectedAlert}
      />

      <ViewAppointmentModal
        selectedAppointment={selectedAppointment}
        setSelectedAppointment={setSelectedAppointment}
        appointments={patient?.appointments}
      />

      <ViewCommunicationModal
        selectedCommunication={selectedCommunication}
        setSelectedCommunication={setSelectedCommunication}
        communication={patient?.communication}
      />

      <NewAppointmentModal
        isOpenAppointmentModal={isOpenAppointmentModal}
        setIsOpenAppointmentModal={setIsOpenAppointmentModal}
        me={me}
        patient={patient}
        scheduleAppointment={scheduleAppointment}
      />

      <EditPatientModal
        isOpen={isOpenEditPatientModal}
        setIsOpenEditPatientModal={setIsOpenEditPatientModal}
        patientId={patient?.id}
        initialFirstName={patient?.name?.[0]?.given?.[0]}
        initialLastName={patient?.name?.[0]?.family}
        initialSex={patient?.gender}
        initialDOB={patient?.birthDate}
        initialEmail={
          patient?.telecom?.find((t) => t.system === 'email')?.value
        }
        initialPhone={
          patient?.telecom?.find((t) => t.system === 'phone')?.value
        }
        initialHealthNumber={
          patient?.identifier?.find(
            (i) => i.system === 'http://hospital.smarthealthit.org'
          )?.value
        }
        initialHeight={
          patient?.observations
            ?.filter(
              (obs) =>
                obs.resource.code?.coding?.[0]?.system === 'http://loinc.org' &&
                obs.resource.code?.coding?.[0]?.code === '8302-2'
            )
            ?.sort(
              (a, b) =>
                new Date(b.effectiveDateTime) - new Date(a.effectiveDateTime)
            )[0]?.resource?.valueQuantity?.value
        }
        organizationId={patient?.managingOrganization?.reference.split('/')[1]}
        initialAssignedLicenseId={
          patient?.extension?.find(
            (ext) =>
              ext.url === 'http://televu.ca/fhir/StructureDefinition/license-id'
          )?.valueString
        }
      />

      <NewMedicationModal
        isOpen={isOpenMedicationModal}
        setIsOpen={setIsOpenMedicationModal}
        handleSubmit={handleAddMedication}
        patientId={id}
        me={me}
      />

      <ViewMedicationModal
        selectedMedication={selectedMedication}
        setSelectedMedication={setSelectedMedication}
        isOpen={isOpenViewMedicationModal}
        setIsOpen={setIsOpenViewMedicationModal}
      />
    </div>
  )
}

export default PatientDetails
